<div nz-row [nzGutter]="16" nzAlign="bottom">
  <div nz-col nzSpan="12">
    <button
      data-test="cancel-button"
      nz-button
      nzType="default"
      [disabled]="loading"
      (click)="cancelDrawerAction()"
    >
      {{ 'general.cancel' | translate }}
    </button>
  </div>
  <div nz-col nzSpan="12">
    <button
      data-test="save-button"
      nz-button
      nzType="primary"
      (click)="saveDrawerAction()"
      [disabled]="loading || saveButtonDisabled"
      [nzLoading]="loading"
    >
      {{ 'general.save' | translate }}
    </button>
  </div>
</div>
